import {
    INavigationProps,
    INavigationItemState,
    useStyles,
    ConvertToNavigationItemState
} from "./shared/Navigation";
import { useHistory } from "react-router-dom";
import React from "react";
import { List, Collapse, ListItem } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

export const ResponsiveNavigationMenu: React.FC<INavigationProps> = navigationProps => {
    const history = useHistory();
    const classes = useStyles(navigationProps?.classes);

    const [navigationItems, setNavigationItems] = React.useState(
        ConvertToNavigationItemState(navigationProps)
    );

    React.useEffect(() => {
        setNavigationItems(ConvertToNavigationItemState(navigationProps));
    }, [navigationProps]);

    const handleClick = (itemState: INavigationItemState) => {
        itemState.open = !itemState.open;
        let updatedItems = [...navigationItems];
        setNavigationItems(updatedItems);
    };

    const navigate = relativePath => {
        history.push(relativePath);
    };

    const getList = (
        list: Array<INavigationItemState>,
        listIndex: number = 0
    ) => {
        return (
            <List key={"list-" + listIndex} className={classes.list}>
                {list.map(function(
                    itemState: INavigationItemState,
                    listItemIndex
                ) {
                    const collapsed = itemState.item.nestedList ? (
                        <Collapse
                            key={"collapse-" + listItemIndex}
                            in={itemState.open}
                            className={classes.collapsedList}
                        >
                            {getList(
                                itemState.item.nestedList.map(function(item) {
                                    return {
                                        item: item,
                                        open: false
                                    };
                                }),
                                ++listIndex
                            )}
                        </Collapse>
                    ) : null;
                    return [
                        <ListItem
                            key={"listItem-" + listItemIndex}
                            className={classes.listItem}
                            onClick={
                                itemState.item.nestedList
                                    ? () => {
                                          handleClick(itemState);
                                      }
                                    : itemState.item.onClick
                                    ? itemState.item.onClick
                                    : () =>
                                          navigate(itemState.item.relativePath)
                            }
                        >
                            <a key={"link-" + listItemIndex}>
                                {itemState.item.title}
                            </a>

                            {itemState.item.nestedList ? (
                                itemState.open ? (
                                    <ExpandLess
                                        key={"icon-" + listItemIndex}
                                        className={classes.collapseIcons}
                                    />
                                ) : (
                                    <ExpandMore
                                        key={"icon-" + listItemIndex}
                                        className={classes.collapseIcons}
                                    />
                                )
                            ) : null}
                        </ListItem>,
                        collapsed
                    ];
                })}
            </List>
        );
    };

    return navigationItems != null ? (
        <nav className={navigationProps.className}>
            {getList(navigationItems)}
        </nav>
    ) : (
        <></>
    );
};
